var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.value !== null)?_c('div',[_c('span',[_vm._v(_vm._s(this.value))]),_c('i',[_vm._v(_vm._s(this.unit))])]):_c('div',[_c('span',[_vm._v(_vm._s(this.$t('common.value.notAvailable')))])])}
var staticRenderFns = []

export { render, staticRenderFns }